export default __webpack_public_path__ + "static/media/warning--dangerous-crosswinds-right--g2.040eb808.png";